<script lang="ts" setup>
import {onMounted, onUnmounted, ref} from 'vue';
import Loader from '@/components/Loader.vue';

defineOptions({
	name: 'GlobalLoader'
});

// Bridge for legacy jQuery code: the payouts page installs a shim over
// window.modal_loader_widget that delegates show/hide/setmessage here, so the
// legacy green-gif overlay is replaced by the Vue Loader without touching the
// shared ajax hooks. A pre-mount buffer (window.__vueLoaderBuffer) covers a
// show() fired before this island finishes mounting.
declare global {
	interface Window {
		vueModalLoader?: VueModalLoaderBridge;
		__vueLoaderBuffer?: { visible: boolean; message: string };
	}
}

interface VueModalLoaderBridge {
	show: (msg?: string) => void;
	hide: () => void;
	setMessage: (msg?: string) => void;
}

const visible = ref(false);
const message = ref('');

const bridge: VueModalLoaderBridge = {
	show(msg?: string) {
		message.value = msg ?? '';
		visible.value = true;
	},
	hide() {
		visible.value = false;
	},
	setMessage(msg?: string) {
		message.value = msg ?? '';
	}
};

onMounted(() => {
	window.vueModalLoader = bridge;
	const buffered = window.__vueLoaderBuffer;
	if (buffered?.visible) {
		bridge.show(buffered.message);
	}
});

onUnmounted(() => {
	if (window.vueModalLoader === bridge) {
		window.vueModalLoader = undefined;
	}
});
</script>

<template>
	<div v-if="visible" class="merit-global-loader">
		<Loader :text="message" size="m"/>
	</div>
</template>

<style scoped>
.merit-global-loader {
	position: fixed;
	inset: 0;
	z-index: 10000;
	background-color: rgba(0, 0, 0, 0.2);
}
</style>
